import react, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import {
  DataGrid,
  GridColDef,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarFilterButton,
  GridValueGetterParams,
  getGridStringOperators,
} from "@mui/x-data-grid";
import styled from "styled-components";
import dayjs from "dayjs";
import clearFilterImage from "../../icons/clearFilter.svg"
import searchIcon from "../../icons/searchIcon.svg"
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import todayCalanerImage from "../../icons/todaysCalander.svg"
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import { CloseOutlined } from "@mui/icons-material";
import Drawer from "../../components/common/drawer/drawer";
import { Typography, Button, Checkbox, Fab, Select, MenuItem, IconButton, DialogContent, Dialog, Modal, Switch, InputLabel, FormControl, TextField, Paper } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import CloseIcon from '@mui/icons-material/Close';
import { ERROR_COLOR } from "../../constants";
import { Add, Save, SaveAlt } from "@mui/icons-material";
import WarehouseModal from "../../components/modals/orderLineItemModal";
import OpaqueLoading from "../../components/opaqueLoading/opaqueLoading";
import VisitModal from "../../components/modals/visitModal";
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import VisitStartModal from "../../components/modals/VisitStartModal";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import TodayVisitModal from "../../components/modals/TodayVisitModal";
import VisitEndModal from "../../components/modals/VisitEndModal";

const isMobile = window.innerWidth < 900;

const StaffEditorPageContainer = styled.div`
  height: ${isMobile ? `auto` : `calc(100vh - 105px)`};
  width: 100%;
  background-color: white;
  padding: 10px 15px;
  ${isMobile &&
  `
      position: relative;
  
      `}
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${isMobile ? "flex-start" : "space-between"};
  margin-bottom: 10px;
  flex-direction: ${isMobile ? "column" : "row"};
`;

const HeaderButtonsContainer = styled.div`
  ${isMobile && "margin-top:10px;"}
`;

const TableContainer = styled.div`
  // height: calc(
  //   100vh - ${isMobile ? "56px - 20px - 82.23px" : "112px - 34px - 43.77px"}
  // );
  width: 100%;
  // border: solid 1px lightGrey;
  border-radius: 8px;
`;
const AvatarContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const DataGridContainer = styled.div`
  max-width: 100%; /* Add this line to limit the width */
  margin: 0 auto; /* Center the content horizontally */
  height: 100%;
  width: 100%;
  border: solid 1px lightGrey;
  border-radius: 8px;
  display: ${isMobile ? 'flex' : 'grid'};

  ${isMobile &&
  `
    flex-direction: column;
  `}
`;

const LoadingContainer = styled.div`
  height: calc(100% - 49px);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const TabsContainer = styled.div`
  ${isMobile &&
  `
    height: calc(100vh - 56px - 20px);
  `}
`;

const GenerateReportButton = styled(Button)`
  margin-right: 10px !important;
`;
const BulkChangePinCodeButton = styled(Button)`
  margin-right: 10px !important;
`;

const PinCodeChangeButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const FabStyle = styled(Fab)`
  && {
    z-index: 1};
  }
`;

const StyledHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default function Visitmanagement() {
  const label = { inputProps: { "aria-label": "Checkbox demo" } };
  const [visitAllDropdown, setVisitAllDropDown] = useState({})
  const [visitType, setVisitType] = useState([])
  const [loading, setLoading] = useState(false);
  const [accessChanges, setAccessChanges] = useState("");
  const [showWarehouseFormModal, setShowWarehouseFormModal] = useState();
  const [visitModal, setVisitModal] = useState(false);
  const [startVisitModal, setStartVisitModal] = useState(false);
  const [endVisitModal, setEndVisitModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [dataModal, setDataModal] = useState();
  const [rowCount, setRowCount] = useState()
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationModel, setPaginationModel] = useState({
    page: currentPage - 1,
    pageSize: 20,
  });
  const [callApi, setCallApi] = useState(false);
        const [accessModulesData, setAccessModulesData] = useState([]);
  const [visitModalData, setVisitModalData] = useState({});
  const [openVisitViewModal, setOpenVisitViewModal] = useState(false);
  const [filter, setFilter] = useState(false)
  const [searchTerm, setSearchTerm] = useState(null)
  const [startDate, setStartDate] = useState("")
  const [endDate, setEndDate] = useState("")
  const [dateRange1, setDateRange1] = useState(false)
  const [startDate1, setStartDate1] = useState()
  const [endDate1, setEndDate1] = useState()
  const [minDate, setMinDate] = useState()
  const [questionCategories, setQuestionCategories] = useState([]);
  const [search, setSearch] = useState()
  const [rm, setRm] = useState("")
  const [rsm, setRsm] = useState("")
  const [asm, setAsm] = useState("")
  const [rsms, setRsms] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [imageModalOpen, setImageModalOpen] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [geoFencing, setGeoFencing] = useState(false);
  const [asms, setAsms] = useState([]);
  const [rms, setRms] = useState([]);
  const [userData, setUserData] = useState(JSON.parse(localStorage.getItem('storedUserData')).user);
  const [newOrderStatus, setNewOrderStatus] = useState("")
  const [errors, setErrors] = useState({
    remark: false,
  });
  const [visitFilters, setVisitFilters] = useState({
    visitStatus: "",
    partyType: "",
    visitType: "",
    visitOutcome: "",
    verifyStatus: ""
  })
  const [endVisitModalOpen, setEndVisitModalOpen] = useState(false);
  const [endVisitForm, setEndVisitForm] = useState({
    startMeetingTime: "",
    endMeetingTime: "",
    endVisitTime: "",
    remark: "",
    mobileNumber: "",
    contactName: "",
    statusOfVisit: "",
    workDone: "",
    productCategory: [],
    feedback: "",
  });
  const [endVisitRow, setEndVisitRow] = useState(null);
  const [statusWork, setStatusWork] = useState([])
  const [workDone, setWorkDone] = useState([])
  const [feedback, setFeedback] = useState([])
  const [openDialog, setOpenDialog] = useState(false);

  const formatDateTime = (inputDateString) => {
    const inputDate = new Date(inputDateString);

    // Check if the input date is valid
    if (isNaN(inputDate.getTime())) {
      return 'Invalid Date';
    }

    // Extract date and time components
    const year = inputDate.getUTCFullYear();
    const month = String(inputDate.getUTCMonth() + 1).padStart(2, '0');
    const day = String(inputDate.getUTCDate()).padStart(2, '0');
    const hours = String(inputDate.getUTCHours()).padStart(2, '0');
    const minutes = String(inputDate.getUTCMinutes()).padStart(2, '0');
    const seconds = String(inputDate.getUTCSeconds()).padStart(2, '0');

    // Format the date string without 'T' and 'Z'
    const formattedDateString = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

    return formattedDateString;

  }
  const [sessions, setSessions] = useState([]); // from API
      const [selectedSession, setSelectedSession] = useState("");
      const [isDateRangeDisabled, setIsDateRangeDisabled] = useState(false);
      const [isSessionDisabled, setIsSessionDisabled] = useState(false);
    const [filteredDate, setFilteredData] = useState({});

        const fetchSessions = async () => {
          try {
            setLoading(true);
            const response = await window.Platform.database.getAllSessions();
            // if (response?.data) {
            //   setSessions(response.data);
            // }
              if (response?.status) {
           const filterdData1 = response?.data?.filter((ele, ind) => ele?.action == "active")
            setFilteredData(filterdData1[0])
          }
          else {
            window.NotificationUtils.showError("Something Went Wrong in session")
          }
          } catch (error) {
            console.error("Error fetching sessions:", error);
            window.NotificationUtils.showError("Failed to load sessions");
          } finally {
            setLoading(false);
          }
        };
  
          useEffect(() => {
            if (!startDate && !endDate) {
              setIsSessionDisabled(false);
            }
          }, [startDate, endDate]);
        
  const getVisitType = async () => {
    let results = await window.Platform.database.getRouteVisitType();
    if(results?.status){
      window.NotificationUtils.showError(results.message);
      setLoading(false);
    }
    else{
      setVisitType(results.data)
      setLoading(false);
    }
  }

  async function getUsers(role, id) {
    if (id != "") {
      let results = await window.Platform.database.getUsersBasedOnManager({ userId: id })
      if (role == 'rsm') {
        setAsms(results?.data)
        setRms(results?.data1)
      }
      if (role == 'asm') {
        setRms(results?.data)
      }
    } else {
      if (role == 'rsm') {
        setRm("")
        setAsm("")
        setRms(allUsers?.filter((ele) => ele.role == 'se'))
        setAsms(allUsers?.filter((ele) => ele.role == 'asm'))
      }
      if (role == 'asm') {
        setRm("")
        setRms(allUsers?.filter((ele) => ele.role == 'se'))
      }
    }
  }


  // Only set up dropdowns, users, and default date on mount. Do NOT call fetchVisits here.
  useEffect(() => {
    fetchSessions();
    fetchAccessModules();
    fetchGeoFencingStatus();
    getStatusOfVisit();
    getWorkDone();
    getFeedback();
    getVisitType();
    getDataForAppDropDown();
    if (userData?.role.toLowerCase().includes('admin')) {
      getAllUsers();
    }
    if (userData?.role === 'rsm') {
      getUsers('rsm', userData?.id);
    }
    if (userData?.role === 'asm') {
      getUsers('asm', userData?.id);
    }
    // Set default date range to yesterday
    // const yesterday = new Date();
    // yesterday.setDate(yesterday.getDate() - 1);
    // const formatted = yesterday.toISOString().split("T")[0];
    // setStartDate(formatted);
    // setEndDate(formatted);
  }, []);

  useEffect(() => {
    setCallApi(true);
    if (callApi) {
      fetchVisits();
    } else {
      // onFilterChange(searchTerm);
    }
  }, [newOrderStatus, paginationModel.page, paginationModel.pageSize]);

  async function getAllUsers() {
    let results = await window.Platform.database.fetchEmployees()
    if (results?.status) {
      window.NotificationUtils.showError(results.message);
      setLoading(false);
      return;
    }
    else {
      setAllUsers(results?.data)
      setRsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'rsm'))
      setRms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'se'))
      setAsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'asm'))
      setLoading(false);
    }
  }


  const getStatusOfVisit = async () => {
    try {
      const results = await window.Platform.database.getStatusType({});
      if(results?.status){
        window.NotificationUtils.showError(results.message);
        setLoading(false);
      }
      else{
        setStatusWork(results.data)
        setLoading(false);
      }
    }
    catch (err) {
      console.log(err)
    }
  }

  
         const fetchAccessModules = async () => {
        try {
            setLoading(true);
            let data = {
                pageNumber: paginationModel.page,
                recordPerPage: paginationModel.pageSize,
                userId : userData?.id,
                moduleId : "d9OZuDKet4"
            }
            let results = await window.Platform.database.fetchAccessModules(data);
            if (results?.status) {
                window.NotificationUtils.showError(results?.message || "Something went wrong");
                setLoading(false);
                return;
            }
            else {
                const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, idIndex: index + 1 }));
                setAccessModulesData(jsonArrayWithId);
            }
        } catch (error) {
            console.error(error);
        }
        finally {
            setLoading(false)
        }
    }

  const getWorkDone = async () => {
    setLoading(true);
    let results = await window.Platform.database.getWorkDone();
    if (results?.status) {
      setLoading(false);
      window.NotificationUtils.showError(results?.message || "Error Fetching Data");
    }
    else {
      setWorkDone(results.data)
      setLoading(false);
    }
  }

  const getFeedback = async () => {
    setLoading(true);
    let results = await window.Platform.database.getFeedback();
    if (results?.status) {
      setLoading(false);
      window.NotificationUtils.showError(results?.message || "Error Fetching Data");
    }
    else {
      setFeedback(results.data)
      setLoading(false);
    }
  }

  const formatTimeStamp = (timestampFromDB) => {
    const options = {
      timeZone: 'Asia/Kolkata',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,  // Use 12-hour clock
    };

    const formattedDate = new Date(timestampFromDB).toLocaleString('en-US', options);

    return formattedDate;
  };

  // const fetchGeoFencingStatus = async () => {
  //   setLoading(true);
  //   try {
  //     const result = await window.Platform.database.getGeoFencingToggle();
  //     if (result.success) {
  //       if (result.data.name === "true") {
  //         setGeoFencing(true);
  //         setLoading(false);
  //       }
  //       else if (result.data.name == "false"){
  //         setGeoFencing(false);
  //         setLoading(false);
  //       }
  //     } else if (result.suceess === "false") {
  //       setLoading(false);
  //     window.NotificationUtils.showError("Error fetching Geo Fencing");
  //     }
  //   } catch (error) {
  //     window.NotificationUtils.showError("Error fetching Geo Fencing");
  //     setLoading(false);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const fetchGeoFencingStatus = async () => {
    setLoading(true);
    try {
      const result = await window.Platform.database.getGeoFencingToggle();
      if (result && result.success && result.data && typeof result.data.name === "string") {
        setGeoFencing(result.data.name === "true");
        // setLoading(false);
      } else {
        window.NotificationUtils.showError("Error fetching Geo Fencing");
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      window.NotificationUtils.showError("Error fetching Geo Fencing");
      setLoading(false);
    }
    finally {
      setLoading(false);
    }
  };

  const handleEndVisitFormChange = (e) => {
    const { name, value } = e.target;
    setEndVisitForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleEndVisitSubmit = async () => {

    if (!endVisitForm.remark.trim()) {
      setErrors({ remark: true });
      return;
    }

    const payload = {
      ...endVisitForm,
      visitId: endVisitRow?.visitId
    };

    console.log("Payload to submit:", payload);
    const result = await window.Platform.database.endVisitByWeb(payload);
    if (result?.status) {
      window.NotificationUtils.showError("Something went wrong!");

    }
    else {
      setEndVisitModalOpen(false);
      window.NotificationUtils.showSuccess(result?.message);
      setEndVisitForm({
        startMeetingTime: "",
        endMeetingTime: "",
        endVisitTime: "",
        remark: "",
        mobileNumber: "",
        contactName: "",
        statusOfVisit: "",
        workDone: "",
        productCategory: [],
        feedback: ""
      });
      setErrors({ remark: false });
    }
  };

  const fetchTest = async () => {
    let results1 = await window.Platform.database.testApi();

  }
  const fetchVisits = async () => {
    setLoading(true);
    try {
      // let results1 = await window.Platform.database.testApi();
      if (startDate > endDate) {
        setLoading(false);
        return window.NotificationUtils.showError("End Date Must Be Greater !!");
      }

      let payload = {
        pageNumber: paginationModel.page,
        recordPerPage: paginationModel.pageSize,
        search: search,
        ownerName: rm,
        rsm: userData?.role == 'rsm' ? userData?.id : rsm,
        asm: userData?.role == 'asm' ? userData?.id : asm,
        // startDate: startDate,
        // endDate: endDate,
          startDate: startDate != '' ? startDate : filteredDate?.startDate,
          endDate: endDate != '' ? endDate : filteredDate?.endDate,
        status: visitFilters?.visitStatus,
        partyType: visitFilters?.partyType == String(0) ? "distributor" : visitFilters?.partyType == 1 ? "school" : "",
        visitType: visitFilters?.visitType,
        visitOutcome: visitFilters?.visitOutcome,
        otp_verified: visitFilters?.verifyStatus,
        visitStatus: newOrderStatus == 1 ? "visit_start" : newOrderStatus == 2 ? "meeting_start" : newOrderStatus == 3 ? "meeting_end" : newOrderStatus == 4 ? "visit_end" : ""
      }
      // let results = await window.Platform.database.fetchVisits(payload);
      let results = await window.Platform.database.fetchAllVisit(payload);
      if (results?.status == false) {
        // if(auth?.user?.role === ROLES.ADMIN){
        setRowCount(results.data1)
        const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, id: index + 1 }));

        setAccessChanges(jsonArrayWithId);
        // }
        // setVisibleEmployees(results);
        setLoading(false);
      }
      else {
        window.NotificationUtils.showError("Error Fetching Data");
        setLoading(false);
      }

    } catch (error) {
      console.error(error);
      window.NotificationUtils.showError("Something Went Wrong");
      setLoading(false);
    }
    // finally {
    //   setLoading(false)
    // }
  }

  const getDataForAppDropDown = async () => {
    setLoading(true);
    try {
      // let results1 = await window.Platform.database.testApi();

      let results = await window.Platform.database.getDataForAppDropDown({});
      if (results?.status == false) {
        setVisitAllDropDown(results?.data);
        // setLoading(false);
      }
      else {
        window.NotificationUtils.showError(results?.message || "Error Fetching Data");
        setLoading(false);
      }

    } catch (error) {
      console.error(error);
      window.NotificationUtils.showError("Error Fetching Data");
      setLoading(false);
    }
    finally {
      setLoading(false)
    }
  }

  const exportOrders = async () => {
    setLoading(true);
    try {
      let data = {
        // asm: asm,
        // rsm: rsm,
        asm: userData?.role === 'asm' ? userData?.id : asm,
        rsm: userData?.role === 'rsm' ? userData?.id : rsm,
        ownerName: rm,
        partyType: visitFilters?.partyType == String(0) ? "distributor" : visitFilters?.partyType == 1 ? "school" : "",
        status: visitFilters?.visitStatus,
        visitOutcome: visitFilters?.visitOutcome,
        visitType: visitFilters?.visitType,
        // startDate: startDate,
        // endDate: endDate,
          startDate: startDate != '' ? startDate : filteredDate?.startDate,
          endDate: endDate != '' ? endDate : filteredDate?.endDate,
        verifyStatus: visitFilters?.verifyStatus
      }
      let result = await window.Platform.database.exportData("/visit/downloadVisitExcel",
        data
      )
      const blob = new Blob([result.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const now = new Date();
      const formattedDate = `${now.getDate().toString().padStart(2, '0')}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getFullYear()}`;
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `VisitReport_${formattedDate}.xlsx`);
      // link.setAttribute("download", "visit.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Export error:", error);
    }
  }
  const exportNewReport = async () => {
    setLoading(true);
    try {
      let data = {
        asm: userData?.role === 'asm' ? userData?.id : asm,
        ownerName: rm,
        rsm: rsm,
        // fromDate: startDate,
        // toDate: endDate,
        partyType: visitFilters?.partyType == String(0) ? "distributor" : visitFilters?.partyType == 1 ? "school" : "",
        visitOutcome: visitFilters?.visitOutcome,
        visitType: visitFilters?.visitType,
        status: visitFilters?.visitStatus,
        // startDate: startDate,
        // endDate: endDate,
          fromDate: startDate != '' ? startDate : filteredDate?.startDate,
          toDate: endDate != '' ? endDate : filteredDate?.endDate,
        verifyStatus: visitFilters?.verifyStatus
      }
      let result = await window.Platform.database.exportData("/visit/downloadVisitSummaryReport", data)
      const blob = new Blob([result.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const now = new Date();
      const formattedDate = `${now.getDate().toString().padStart(2, '0')}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getFullYear()}`;
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Visit_Summary_Report_${formattedDate}.xlsx`);
      // link.setAttribute("download", "visit.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Export error:", error);
    }
  }

  const exportSalesReport = async () => {
    setLoading(true);
    try {
      let data = {
        asm: userData?.role === 'asm' ? userData?.id : asm,
        ownerName: rm,
        rsm: rsm,
        // fromDate: startDate,
        // toDate: endDate,
          fromDate: startDate != '' ? startDate : filteredDate?.startDate,
          toDate: endDate != '' ? endDate : filteredDate?.endDate,
        partyType: visitFilters?.partyType == String(0) ? "distributor" : visitFilters?.partyType == 1 ? "school" : "",
        visitOutcome: visitFilters?.visitOutcome,
        visitType: visitFilters?.visitType,
        status: visitFilters?.visitStatus,
        // startDate: startDate,
        // endDate: endDate,
        verifyStatus: visitFilters?.verifyStatus
      }
      let result = await window.Platform.database.exportData("/visit/downloadSalesVisitSummaryReport", data)
      const blob = new Blob([result.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const now = new Date();
      const formattedDate = `${now.getDate().toString().padStart(2, '0')}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getFullYear()}`;
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Visit_Pattern_Report_${formattedDate}.xlsx`);
      // link.setAttribute("download", "visit.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Export error:", error);
    }
  }

  const exportSummary = async () => {
    setLoading(true);
    try {
      let data = {
        asm: asm,
        ownerName: rm,
        partyType: visitFilters?.partyType == String(0) ? "distributor" : visitFilters?.partyType == 1 ? "school" : "",
        rsm: rsm,
        status: visitFilters?.visitStatus,
        visitOutcome: visitFilters?.visitOutcome,
        visitType: visitFilters?.visitType,
        // startDate: startDate,
        // endDate: endDate,
          startDate: startDate != '' ? startDate : filteredDate?.startDate,
          endDate: endDate != '' ? endDate : filteredDate?.endDate,
        verifyStatus: visitFilters?.verifyStatus
      }
      let result = await window.Platform.database.exportData("/visit/downloadVisitSummary", data)
      const blob = new Blob([result.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const now = new Date();
      const formattedDate = `${now.getDate().toString().padStart(2, '0')}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getFullYear()}`;
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Working_Summary_${formattedDate}.xlsx`);
      // link.setAttribute("download", "visit.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Export error:", error);
    }
  }
  const exportQuickSummary = async () => {
    setLoading(true);
    try {
      let data = {
        asm: asm,
        ownerName: rm,
        rsm: rsm
      }
      let result = await window.Platform.database.exportData("/visit/downloadQuickSummary", data)
      const blob = new Blob([result.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const now = new Date();
      const formattedDate = `${now.getDate().toString().padStart(2, '0')}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getFullYear()}`;
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Quick_Summary_School_${formattedDate}.xlsx`);
      // link.setAttribute("download", "visit.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Export error:", error);
    }
  }

  const downloadDistributorQuickSummary = async () => {
    setLoading(true);
    try {
      let data = {
        asm: asm,
        ownerName: rm,
        rsm: rsm
      }
      let result = await window.Platform.database.exportData("/visit/downloadDistributorQuickSummary", data)
      const blob = new Blob([result.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const now = new Date();
      const formattedDate = `${now.getDate().toString().padStart(2, '0')}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getFullYear()}`;
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Quick_Summary_Distributor_${formattedDate}.xlsx`);
      // link.setAttribute("download", "visit.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Export error:", error);
    }
  }
  const getQuestionCategory = async () => {
    try {
      setLoading(true);
      let result = await window.Platform.database.getQuestionCategory({});
      if (result?.status && Array.isArray(result.data)) {
        setQuestionCategories(result.data);
      }
      console.log("Question categories:", result);
    } catch (error) {
      console.error("Error fetching question categories", error);
      window.NotificationUtils.showError("Error fetching question categories");
    }
    // finally {
    //   setLoading(false);
    // }
  };

  // const handleOpenVisitModal = (data) => {
  //   setVisitModalData(data)
  //   setOpenVisitViewModal(true)
  //   getQuestionCategory()
  // }
  const handleOpenVisitModal = async (rowData) => {
    setLoading(true);
    try {
      const result = await window.Platform.database.fetchVisitById({ visitId: rowData.visitId });
      if (result?.status === false && result.data) {
        setVisitModalData(result.data);
        setOpenVisitViewModal(true);
        getQuestionCategory();
        setLoading(false);
      } else {
        window.NotificationUtils.showError("Could not fetch visit details");
        setLoading(false);
      }
    } catch (error) {
      window.NotificationUtils.showError("Error fetching visit details");
    }
    // finally {
    //   setLoading(false);
    // }
  };

  const handleCloseVisitViewModal = () => {
    setOpenVisitViewModal(false);
    setVisitModalData({})
  };

  // const endVisitDirect = async (rowData) => {
  //   console.log(rowData, "rowData of end visit direct", rowData?.visitId)
  //   setEndVisitRow(rowData);
  //   setEndVisitModalOpen(true);
  // }
  const endVisitDirect = async (rowData) => {
    console.log(rowData, "rowData of end visit direct", rowData)
    setEndVisitRow(rowData);
    setEndVisitForm({
      startMeetingTime: rowData?.start_time_meeting || "",
      endMeetingTime: rowData?.end_time_meeting || "",
      endVisitTime: rowData?.endTime || "",
      remark: "",
      mobileNumber: "",
      contactName: "",
      statusOfVisit: "",
      workDone: "",
      productCategory: [],
      feedback: ""
    });
    setEndVisitModalOpen(true);
  }

  const handleStartMeetingChange = (newValue) => {
    setEndVisitForm((prev) => ({
      ...prev,
      startMeetingTime: newValue ? newValue.toISOString() : "",
    }));
  };

  const clearFilters = async () => {
    setLoading(true);
    setStartDate("")
    setEndDate("")
    setRm("")
    setRsm("")
    setAsm("")
    setNewOrderStatus("")
    setVisitFilters({
      visitStatus: "",
      partyType: "",
      visitType: "",
      visitOutcome: "",
      verifiStatus: ""
    })
      setAccessChanges([]);
      setSelectedSession("");
    setRowCount(0);
    setRsms(allUsers?.filter((ele) => ele.role.toLowerCase() === 'rsm'));
    setRms(allUsers?.filter((ele) => ele.role.toLowerCase() === 'se'));
    setAsms(allUsers?.filter((ele) => ele.role.toLowerCase() === 'asm'));
    // setPaginationModel((prev) => ({ ...prev, pageSize: 20 }))
    setPaginationModel({
      page: 0,
      pageSize: 20,
    });
    setLoading(false);
  }

  const handleGeoFencingToggle = async () => {
    setLoading(true);
    try {
      const payload = { isFencingEnabled: (!geoFencing).toString() };
      const result = await window.Platform.database.geoFencingToggle(payload);
      if (result && result.success) {

        geoFencing ? setGeoFencing(false) : setGeoFencing(true);
        window.NotificationUtils.showSuccess(result?.message || "Geo Fencing toggled successfully");
        await fetchGeoFencingStatus();
      } else {
        window.NotificationUtils.showError(result?.message || "Failed to toggle Geo Fencing");
      }
    } catch (error) {
      console.log(error);
      window.NotificationUtils.showError("Error toggling Geo Fencing");
    }
    // finally {
    //   setLoading(false);
    // }
  };

  const showImages = (pictures) => {
    // console.log(window.Platform.database.funcForBaseURL() + "/file" + pictures, ";;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;")
    const url = window.Platform.database.funcForBaseURL() + "/file" + pictures;
    setImageUrl(url);
    setImageModalOpen(true);
  }

  const rejectVisit = async (visitId) => {
    try {
      setLoading(true);
      await window.Platform.database.rejectVisit({ id: visitId });
      await fetchVisits();
      setLoading(false);
    } catch (error) {
      console.error(error);
      window.NotificationUtils.showError("Error Rejecting School");
      setLoading(false);
    }
  }

  const getEmployeeColumns = () => {
    const stringOperators = getGridStringOperators().filter((op => ['contains'].includes(op.value)));

    let result = [
      {
        field: "partyIDD1",
        headerName: "Party ID",
        width: 130,
        sortable: false,
        filterOperators: stringOperators,
        valueGetter: (params) => {
          return (params.row.partyId || "N/A");
        },
        renderCell: (params) => {
          let name = params.row?.partyId || "N/A"
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "partyName",
        headerName: "Party Name",
        filterable: false,
        width: 250,

        filterOperators: stringOperators,
        editable: false,
        valueGetter: (params) => {
          if (params.row?.schoolName) {
            return (params.row.schoolName || "N/A");
          } else {
            return (params.row.DistributorName || "N/A")
          }
        },
        renderCell: (params) => {

          let name = params.row?.schoolName ? params.row.schoolName : params.row.DistributorName || "N/A"

          return (

            <Tooltip title={name || "N/A"}>

              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>

            </Tooltip>

          )

        },
      },
      {
        field: "visit done name",
        headerName: "Visit Done By",
        width: 150,
        sortable: false,
        filterOperators: stringOperators,
        valueGetter: (params) => {
          return (params.row.u_name || "N/A");
        },
        renderCell: (params) => {
          let name = params.row?.u_name || "N/A"
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "TaggedColluge",
        headerName: "Tagged Colleague",
        width: 150,
        sortable: false,
        filterOperators: stringOperators,
        valueGetter: (params) => {
          return (params.row.tag_user_name || "N/A");
        },
        renderCell: (params) => {
          let name = params.row?.tag_user_name || "N/A"
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "VisitType",
        headerName: "Visit Type",
        width: 140,
        sortable: false,
        filterable: false,
        valueGetter: (params) => {
          // return (params.row.typeName || "N/A");
          // return (visitType && visitType?.filter((ele)=> {
          //   if(ele?.routeVisitTypeID == params.row.typeName){
          //     return ele?.routeVisitType
          //   }
          // })|| "N/A");
          let name = visitType?.find(
            (ele) => ele?.routeVisitTypeID === params.row.typeName
          )?.routeVisitType || "N/A";
        },
        renderCell: (params) => {
          // let name = params.row?.typeName || "N/A";
          //  let name =(visitType && visitType?.filter((ele)=> {
          //   if(ele?.routeVisitTypeID == params.row.typeName){
          //     return ele?.routeVisitType
          //   }
          // })|| "N/A");
          let name = visitType?.find(
            (ele) => ele?.routeVisitTypeID === params.row.typeName
          )?.routeVisitType || "N/A";

          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "Status",
        headerName: "Visit Status",
        width: 130,
        filterable: false,
        sortable: false,
        valueGetter: (params) => {
          return (params.row.visited_status == 1 ? "Visit Started" : params.row.visited_status == 2 ? "Meeting Started" : params.row.visited_status == 3 ? "Meeting Ended" : params.row.visited_status == 4 ? "Visit Completed" : "N/A" || "N/A");
        },
        renderCell: (params) => {
          let name = params.row.visited_status == 1 ? "Visit Started" : params.row.visited_status == 2 ? "Meeting Started" : params.row.visited_status == 3 ? "Meeting Ended" : params.row.visited_status == 4 ? "Visit Completed" : "N/A" || "N/A"
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "Date",
        headerName: "Date",
        width: 110,
        filterable: false,
        sortable: false,
        valueGetter: (params) => {
          const dateStr = params.row.startTime;
          if (!dateStr) return "N/A";
          const dateObj = new Date(dateStr);
          if (isNaN(dateObj.getTime())) return "N/A";
          // Format: 15 Jun 2025
          const day = String(dateObj.getDate()).padStart(2, '0');
          const month = dateObj.toLocaleString('en-US', { month: 'short' });
          const year = dateObj.getFullYear();
          return `${day} ${month} ${year}`;
        },
        renderCell: (params) => {
          const dateStr = params.row?.startTime;
          if (!dateStr) return <Tooltip title="N/A"><Typography variant="inherit">N/A</Typography></Tooltip>;
          const dateObj = new Date(dateStr);
          if (isNaN(dateObj.getTime())) return <Tooltip title="N/A"><Typography variant="inherit">N/A</Typography></Tooltip>;
          const day = String(dateObj.getDate()).padStart(2, '0');
          const month = dateObj.toLocaleString('en-US', { month: 'short' });
          const year = dateObj.getFullYear();
          const formatted = `${day} ${month} ${year}`;
          return (
            <Tooltip title={formatted}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{formatted}</Typography>
            </Tooltip>
          );
        },
      },
      {
        field: "View",
        headerName: "View",
        minWidth: 100,
        filterable: false,
        sortable: false,
        renderCell: (params) => {
          return (
            <>
              <Tooltip>
                <span>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={() => handleOpenVisitModal(params.row)}
                    sx={{ minWidth: "80px" }}
                  >
                    {"View"}
                  </Button>
                </span>
              </Tooltip>
              <Modal open={openVisitViewModal} onClose={handleCloseVisitViewModal}>
                <Box
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "80%",
                    maxWidth: 900,
                    bgcolor: "white",
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                    maxHeight: "90%",
                    overflowY: "auto",
                  }}
                >
                  <Typography variant="h6" component="h2" style={{ textAlign: "center" }} sx={{ color: "black", fontSize: "16px", fontWeight: "600" }}>
                    Visit Details
                  </Typography>
                  <IconButton onClick={() => setOpenVisitViewModal(false)} style={{ position: "absolute", top: 10, right: 10 }}>
                    <CloseOutlined />
                  </IconButton>
                  {/* <hr style={{ width: "100%", color:"black", fontWeight:"800" }} /> */}
                  <hr style={{ width: "100%", border: "none", borderTop: "2px solid #222", margin: "16px 0" }} />
                  <div>
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <b> Party Id : </b> <span >{visitModalData[0]?.partyId || "N/A"}</span>
                      </div>
                      <div className="col-md-6">
                        <b> Party Name :</b> {visitModalData[0]?.schoolName ? visitModalData[0]?.schoolName : visitModalData[0]?.DistributorName || "N/A" || "N/A"}
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-md-6">
                        {/* <b>Visit Start Time : </b> {visitModalData[0]?.startTime || "N/A"} */}
                        <b>Visit Start Time : </b>
                        {visitModalData[0]?.startTime
                          ? new Date(visitModalData[0].startTime).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })
                          : "N/A"}
                      </div>
                      <div className="col-md-6">
                        <b>Meeting Start Time : </b>
                        {/* {visitModalData[0]?.start_time_meeting || "N/A"} */}
                        {visitModalData[0]?.start_time_meeting
                          ? new Date(visitModalData[0].start_time_meeting).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })
                          : "N/A"}
                      </div>

                    </div>
                    <div className="row mb-3">

                      <div className="col-md-6">
                        <b>MeetingEnd Tiime :</b>
                        {/* {visitModalData[0]?.end_time_meeting || "N/A"} */}
                        {visitModalData[0]?.end_time_meeting
                          ? new Date(visitModalData[0].end_time_meeting).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })
                          : "N/A"}
                      </div>
                      <div className="col-md-6">
                        <b>Visit End Tiime :</b>
                        {/* {visitModalData[0]?.endTime || "N/A"} */}
                        {visitModalData[0]?.endTime
                          ? new Date(visitModalData[0].endTime).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })
                          : "N/A"}
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <b>Visit Done By : </b> {visitModalData[0]?.u_name || "N/A"}
                      </div>
                      <div className="col-md-6">
                        <b> Visit Purpose :</b> {visitModalData[0]?.typeName || "N/A"}
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <b> Time taken from last point: </b> {visitModalData[0]?.time_taken_from_last_visit || "N/A"}
                      </div>
                      <div className="col-md-6">
                        {/* <b> Distance from last visit :</b> {(visitModalData[0]?.distance_from_last_visit == 0 ? 0 : visitModalData[0].distance_from_last_visit) + " KM" || "N/A"} */}
                        <b> Distance from last point :</b>{" "}
                        {visitModalData[0]?.distance_from_last_visit === 0
                          ? "0 KM"
                          : visitModalData[0]?.distance_from_last_visit
                            ? `${visitModalData[0].distance_from_last_visit} KM`
                            : "N/A"}

                      </div>
                    </div>
                    {/* <div className="row mb-2">
                      <div className="col-12">
                        <b> Is Decision Maker / School Authority Available For Meeting : </b> <span style={{ fontWeight: "500" }}>{visitModalData[0]?.meeting_with_decision_maker?.toUpperCase() || "N/A"}</span>
                      </div>
                    </div> */}
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <b> Contact Person Name : </b> {visitModalData[0]?.ContactPerson || "N/A"}
                      </div>
                      <div className="col-md-6">
                        <b> Contact Person Number :</b> {visitModalData[0]?.PhoneNumber || "N/A"}
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <b> Visit Status : </b> {visitModalData[0]?.statusTypeName || "N/A"}
                      </div>
                      <div className="col-md-6">
                        <b> Work Done :</b> {visitModalData[0]?.workDoneName || "N/A"}
                      </div>
                    </div>

                    <div className="row mb-3">
                      <div className="col-md-6">
                        <b> Start Visit Address : </b> {visitModalData[0]?.start_address || "N/A"}
                      </div>
                      <div className="col-md-6">
                        <b>  End Visit Address : </b> {visitModalData[0]?.end_address || "N/A"}
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <b>Visit Start Remark : </b> {visitModalData[0]?.extra || "N/A"}
                      </div>
                      <div className="col-md-6">
                        <b>Visit End Remark : </b> {visitModalData[0]?.visitEndRemark || "N/A"}
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <b> Visit OutCome : </b> {visitModalData[0]?.name || "N/A"}
                      </div>
                      <div className="col-md-6">

                        <b> Next Step Name : </b> {visitModalData[0]?.nextStepName || "N/A"}

                      </div>

                    </div>
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <b> Follow Up Date : </b>
                        {/* {visitModalData[0]?.followUpDate || "N/A"} */}
                        {visitModalData[0]?.followUpDate
                          ? new Date(visitModalData[0].followUpDate).toLocaleDateString('en-GB')
                          : "N/A"}
                      </div>
                      <div className="col-md-6">
                        <b>Follow Up Remark  : </b>
                        {visitModalData[0]?.followUpRemark || "N/A"}
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-md-6">

                        <b> Supervisor : </b> {visitModalData[0]?.reportingManagerOfTaggedUser || "N/A"}
                      </div>
                      <div className="col-md-6" style={{ display: "flex", alignItems: "center", gap: 8 }}>

                        <b> Colleague : </b> {visitModalData[0]?.tag_user || "N/A"}

                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-md-6">
                        <b >View Image</b>
                        <IconButton
                          variant="extended"
                          disabled={!visitModalData[0]?.start_image}
                          color="primary"
                          onClick={e => {
                            e.stopPropagation();
                            showImages(visitModalData[0]?.start_image);
                          }}
                          sx={{ ml: 1 }}
                        >
                          <RemoveRedEyeIcon />
                        </IconButton>
                      </div>
                      <div className="col-md-6">
                        <b> Time Taken From Last Visit (In Minutes) :</b> {visitModalData[0]?.time_taken_last_visit || "N/A"}
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <b style={{ color: "black" }}> Ho Remark : </b>
                        <span style={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{visitModalData[0]?.ho_need_remark || "N/A"}</span>
                      </div>
                      <div className="col-md-6">
                        <b> Feedback : </b> {visitModalData[0]?.feedbackName || "N/A"}
                      </div>
                    </div>
                    <div className="row mb-3">
                      {(() => {
                        const furtherVisit = visitModalData[0]?.furtherVisitRequired
                          ? JSON.parse(visitModalData[0]?.furtherVisitRequired)
                          : null;

                        return (
                          <>
                            <div className="col-md-6">
                              <b style={{ color: "black" }}> Further Visit Required :</b>
                              <span style={{ color: "black", fontSize: "13px", fontWeight: "500" }}>
                                {furtherVisit
                                  ? furtherVisit.visit_required
                                    ? "Yes"
                                    : "No"
                                  : "N/A"}
                              </span>
                            </div>

                            <div className="col-md-6">
                              <b style={{ color: "black" }}> Further Visit Remark :</b>
                              <span style={{ color: "black", fontSize: "13px", fontWeight: "500" }}>
                                {furtherVisit?.reason || "N/A"}
                              </span>
                            </div>
                          </>
                        );
                      })()}

                    </div>
                    <div className="row mt-4">
                      <div className="col-12">
                        <span style={{ fontWeight: "600", color: "black" }}>Product Category:</span>
                        {
                          (() => {
                            let raw = visitModalData[0]?.product_category;
                            if (!raw) return "N/A";
                            try {
                              if (typeof raw === "string") raw = JSON.parse(raw);
                              if (typeof raw === "string") raw = JSON.parse(raw);
                              if (raw && raw.interested) {
                                return (
                                  // <span style={{ marginLeft: 10 }}>
                                  //   <div style={{ color: "black", fontWeight: 500 }}>Remark :- {raw?.interested}</div>
                                  // </span>
                                  <div className="mt-1 shadow-lg pl-4 p-2" >
                                    <div>
                                      <span style={{ fontWeight: 700, color: "#000000ff" }}> Remark :- </span><span style={{ color: "black", fontWeight: "500" }}>  {raw?.interested}</span>

                                    </div>
                                    <div style={{ color: "#444", fontWeight: 500 }}>
                                    </div>
                                  </div>
                                );
                              }

                              let dataArr = raw?.data && Array.isArray(raw?.data) ? raw.data : [];
                              // if (!dataArr.length) return "N/A";

                              const grouped = {};
                              if (raw && raw?.interested == null) {
                                dataArr.forEach(item => {
                                  if (item && item.category) {
                                    if (!grouped[item.category]) grouped[item.category] = [];
                                    grouped[item.category].push(item);
                                  }
                                });
                                return Object.keys(grouped)?.map((cat, i) => {
                                  const catName = questionCategories.find(qc => String(qc.id) === String(cat))?.name || cat;
                                  return (
                                    <div key={cat} className="shadow-sm" style={{ background: "#ffffff", border: "1px solid #ddd", borderRadius: 10, padding: "15px 20px", marginBottom: 20 }}>
                                      <div style={{ color: "#1976d2", fontSize: 16, fontWeight: 700, borderBottom: "1px solid #ccc", paddingBottom: 8, marginBottom: 12 }}>
                                        Category: {catName}
                                      </div>
                                      {grouped[cat]?.map((item, idx) => (
                                        <div key={idx} style={{ borderBottom: idx !== grouped[cat].length - 1 ? "1px dashed #bbb" : "none", marginBottom: 10, paddingBottom: 10 }}>
                                          {Object.entries(item)
                                            .filter(([k]) => k !== "category" && k !== "title")
                                            .map(([k, v], i) => (
                                              <div key={i} style={{ marginBottom: 4 }}>
                                                <span style={{ fontWeight: 700, color: "#222" }}>{k.replace(/_/g, " ")}:</span>{" "}
                                                <span style={{ fontWeight: 400, color: "#444" }}>{v === null || v === undefined || v === "" ? "N/A" : (Array.isArray(v) ? v.join(", ") : String(v))}</span>
                                              </div>
                                            ))}
                                        </div>
                                      ))}
                                    </div>
                                  );
                                });
                              }
                            } catch (e) {
                              return "N/A";
                            }
                          })()
                        }
                      </div>
                    </div>

                  </div>
                  <Box mt={2} display="flex" justifyContent="flex-end">
                    <Button onClick={handleCloseVisitViewModal} variant="contained" color="primary">
                      Close
                    </Button>
                  </Box>
                </Box>
              </Modal>
            </>
          );
        },
      },
      // (newOrderStatus == 1 || newOrderStatus == 2 || newOrderStatus == 3) && {
      //   field: "endVisit",
      //   headerName: "End Visit",
      //   width: 130,
      //   filterable: false,
      //   sortable: false,
      //   renderCell: (params) => {
      //     return (
      //       <Button
      //         variant="contained"
      //         color="info"
      //         size="small"
      //         onClick={() => endVisitDirect(params.row)}
      //         sx={{ minWidth: "80px" }}
      //       >
      //         End Visit
      //       </Button>
      //     )
      //   },
      // },
      // {

      //   field: "Actions",

      //   headerName: "Actions",

      //   // editable: false,
      //   // filterable: false,

      //   filterable: false,
      //   sortable: false,
      //   // hide: true,

      //   minWidth: 150,
      //   headerAlign: 'center',
      //   // disableExport: true,


      //   renderCell: (params) => {


      //     return (

      //       <>
      //         <Tooltip title={"Edit Visit"}>
      //           <IconButton onClick={() => handleEdit(params.row)} disabled={!params.row?.status}>
      //             <DriveFileRenameOutlineIcon sx={{ color: "black", fontSize: "22px", fontWeight: "400" }} />
      //           </IconButton>
      //         </Tooltip>
      //         <Tooltip title="">
      //           <IconButton disabled={!params.row?.status} variant="extended" sx={{ color: "red" }} onClick={(e) => {
      //             e.stopPropagation();
      //             rejectVisit(params.row.visitId);
      //           }} >
      //             <ThumbDownIcon />
      //           </IconButton>
      //         </Tooltip>
      //         {/* <Tooltip title="">
      //           <IconButton variant="extended" disabled={!params.row.start_image} color="primary" onClick={(e) => {
      //             e.stopPropagation();
      //             showImages(params.row.start_image);
      //           }} >
      //             <RemoveRedEyeIcon />
      //           </IconButton>
      //           <IconButton variant="extended" disabled={!params.row.end_image} color="primary" onClick={(e) => {
      //             e.stopPropagation();
      //             showImages(params.row.end_image);
      //           }} >
      //             <RemoveRedEyeIcon />
      //           </IconButton>
      //         </Tooltip> */}
      //       </>

      //     )

      //   },

      // }

    ].filter(Boolean);


    return result
  }

  function CustomToolbar() {
    return (
      <GridToolbarContainer className="">
        <Button
          onClick={() => setNewOrderStatus("")}
          style={{ backgroundColor: newOrderStatus === "" ? "#8787f470" : "white", color: newOrderStatus === "" ? "black" : "black", fontWeight: "500", }}>
          All
        </Button>
        <Button
          onClick={() => setNewOrderStatus(1)}
          style={{ backgroundColor: newOrderStatus === 1 ? "#D09F39" : "white", color: newOrderStatus === 1 ? "white" : "black", fontWeight: "500", }}>
          Visit Started
        </Button>
        <Button
          onClick={() => setNewOrderStatus(2)}
          style={{ backgroundColor: newOrderStatus === 2 ? "#61d2ff" : "white", color: newOrderStatus === 2 ? "black" : "black", fontWeight: "500", }}>
          Meeting Started
        </Button>
        <Button
          onClick={() => setNewOrderStatus(3)}
          style={{ backgroundColor: newOrderStatus === 3 ? "#f05dc3" : "white", color: newOrderStatus === 3 ? "black" : "black", fontWeight: "500", }}>
          Meeting Ended
        </Button>
        <Button
          onClick={() => setNewOrderStatus(4)}
          style={{ backgroundColor: newOrderStatus === 4 ? "green" : "white", color: newOrderStatus === 4 ? "white" : "black", fontWeight: "500", }}>
          Visit Completed
        </Button>
        <Typography sx={{ fontSize: "14px", fontWeight: "500", color: "black" }} className="ml-4">Select Page Size:&nbsp; </Typography>
        <Select
          value={paginationModel.pageSize}
          variant="outlined"
          size="small"
          onChange={(e) => { setPaginationModel({ ...paginationModel, pageSize: e.target.value }) }}
          sx={{ width: 90, fontSize: "14px", fontWeight: "500", color: "black" }}
        >
          {[10, 20, 30, 50, 100].map((role) => (
            <MenuItem key={role} value={role} sx={{ fontSize: "14px", fontWeight: "500", color: "black" }}>{role}</MenuItem>
          ))}
        </Select>
      </GridToolbarContainer>
    );
  }

  const onFilterChange = async (filterModel) => {


    try {
      setLoading(true);
      setFilter(true)
      if (filterModel) {
        const response = await window.Platform.database.filterVisit({ filterField: filterModel?.field, filterValue: filterModel?.value, pageNumber: paginationModel.page, startDate: startDate, endDate: endDate })
        const jsonArrayWithId = response?.data?.map((obj, index) => ({ ...obj, id: index + 1 }));
        setAccessChanges(jsonArrayWithId)
        setRowCount(response.data1)
        setLoading(false);
      }
      else {
        const response = await window.Platform.database.filterVisit({ filterField: "date", pageNumber: paginationModel.page, startDate: startDate, endDate: endDate })
        const jsonArrayWithId = response?.data?.map((obj, index) => ({ ...obj, id: index + 1 }));
        setAccessChanges(jsonArrayWithId)
        setRowCount(response.data1)
        setLoading(false);
      }
    }
    catch (err) {
      console.error(err)
      setLoading(false);
      window.NotificationUtils.showError("Error While Recieving Data Please Wait and try again");
    }

  };
  const renderContent = () => {
    return (
      <Box sx={{ height: "100%", width: "100%" }}>
        <DataGridContainer style={{ height: !accessChanges?.length ? '200px' : 'auto' }}>
          <DataGrid
            className="payrollGrid"
            //   checkboxSelection={true}
            density="compact"
            rows={accessChanges || []}
            columns={getEmployeeColumns()}
            sx={{ color: "black", fontSize: "14px", fontWeight: "600" }}
            disableSelectionOnClick
            disableRowSelectionOnClick
            rowHeight={60}
            disableDensitySelector
            onFilterModelChange={(val) => {
              if (val?.items[0]?.value?.length > 0) {
                // onFilterChange(val.items[0])
                setSearchTerm(val.items[0])
              }
              else if (!val.items[0]?.value && startDate && endDate) {
                setSearchTerm(null)
                // onFilterChange()
              }
              else {
                setLoading(true)
                fetchVisits()
                setFilter(false)
                setSearchTerm(null)
              }
            }

            }
            filterMode="server"

            rowCount={rowCount}

            paginationModel={paginationModel}
            paginationMode="server"
            onPaginationModelChange={setPaginationModel}
            pageSizeOptions={[10]}


            components={{
              Toolbar: CustomToolbar,
            }}
          />
        </DataGridContainer>
      </Box>
    );
  };

  // const renderContent = () => {
  //   const today = new Date();
  //   today.setHours(0, 0, 0, 0); // reset time

  //   const todayVisits = (accessChanges || []).filter(row => {
  //     const start = new Date(row.startTime);
  //     start.setHours(0, 0, 0, 0);
  //     return start.getTime() === today.getTime();
  //   });

  //   const previousVisits = (accessChanges || []).filter(row => {
  //     const start = new Date(row.startTime);
  //     start.setHours(0, 0, 0, 0);
  //     return start.getTime() < today.getTime();
  //   });

  //   return (
  //     <Box sx={{ height: "100%", width: "100%" }}>
  //       {/* Today's Visits Section */}
  //       {todayVisits.length > 0 ? (
  //         <>
  //           <Typography style={{ float: "left", marginLeft: "10px" }} variant="h6" sx={{ color: "black", fontWeight: 600, my: 2 }}>
  //             Today's Visits
  //           </Typography>
  //           <DataGridContainer style={{ marginBottom: "20px" }}>
  //             <DataGrid
  //               className="payrollGrid"
  //               density="compact"
  //               rows={todayVisits}
  //               columns={getEmployeeColumns()}
  //               sx={{ color: "black", fontSize: "14px", fontWeight: "600" }}
  //               disableSelectionOnClick
  //               disableRowSelectionOnClick
  //               rowHeight={60}
  //               hideFooter={true}
  //               disableDensitySelector
  //               components={{ Toolbar: CustomToolbar }}
  //             />
  //           </DataGridContainer>
  //         </>
  //       ) :
  //         <>
  //         </>
  //       }

  //       {/* Previous Visits Section */}
  //       {previousVisits.length > 0 && (
  //         <>
  //           <Typography style={{ float: "left", marginLeft: "10px" }} variant="h6" sx={{ color: "black", fontWeight: 600, my: 2 }}>
  //             Previous Visits
  //           </Typography>
  //           <DataGridContainer>
  //             <DataGrid
  //               className="payrollGrid"
  //               density="compact"
  //               rows={previousVisits}
  //               columns={getEmployeeColumns()}
  //               sx={{ color: "black", fontSize: "14px", fontWeight: "600" }}
  //               disableSelectionOnClick
  //               disableRowSelectionOnClick
  //               rowHeight={60}
  //               disableDensitySelector
  //               components={{ Toolbar: CustomToolbar }}
  //               paginationModel={paginationModel}
  //               paginationMode="server"
  //               onPaginationModelChange={setPaginationModel}
  //               pageSizeOptions={[10]}
  //               rowCount={rowCount}
  //             />
  //           </DataGridContainer>
  //         </>
  //       )}

  //       {/* Fallback if no data at all */}
  //       {todayVisits.length === 0 && previousVisits.length === 0 && (
  //         <Typography variant="body1" sx={{ color: "gray", mt: 4, textAlign: "center" }}>
  //           No visit records available.
  //         </Typography>
  //       )}
  //     </Box>
  //   );
  // };

  const addVisit = () => {
    setVisitModal(true)
  }
  const addStartVisit = () => {
    setStartVisitModal(true);
  }
  const addEndVisit = () => {
    setEndVisitModal(true);
  }
  const handleEdit = (data) => {
    setEditModal(true)
    setDataModal(data)
  }
  const formatDate = async (data) => {
    setMinDate(data)
    setDateRange1(true)
    setEndDate1(null)
    setEndDate(null)
    const datePickerResponse = new Date(data.$d);

    const year = datePickerResponse.getFullYear();
    const month = String(datePickerResponse.getMonth() + 1).padStart(2, '0');
    const day = String(datePickerResponse.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;

    setStartDate1(formattedDate)
    setStartDate(formattedDate)
  }
  const finalDateRangeFilter = async (data) => {
    try {
      setLoading(true)
      setFilter(true)

      const datePickerResponse = new Date(data);

      const year = datePickerResponse.getFullYear();
      const month = String(datePickerResponse.getMonth() + 1).padStart(2, '0');
      const day = String(datePickerResponse.getDate()).padStart(2, '0');
      const formattedDate = `${year}-${month}-${day}`;

      if (data) {
        setEndDate(formattedDate)
        setEndDate1(formattedDate)
      }
      if (searchTerm) {
        const response = await window.Platform.database.filterVisit({ filterField: searchTerm.field, filterValue: searchTerm?.value, pageNumber: paginationModel.page, startDate: startDate, endDate: data ? formattedDate : endDate })
        const jsonArrayWithId = response?.data?.map((obj, index) => ({ ...obj, id: index + 1 }));
        setAccessChanges(jsonArrayWithId)
        setRowCount(response.data1)

      }
      else {
        const response = await window.Platform.database.filterVisit({ filterField: "date", filterValue: searchTerm?.value, pageNumber: paginationModel.page, startDate: startDate, endDate: data ? formattedDate : endDate })
        const jsonArrayWithId = response?.data?.map((obj, index) => ({ ...obj, id: index + 1 }));
        setAccessChanges(jsonArrayWithId)
        setRowCount(response.data1)

      }
      setLoading(false)

    }
    catch (err) {
      console.log(err)
      setLoading(false)
      window.NotificationUtils.showError("Error While Recieving Data Please Wait and try again");

      fetchVisits()

    }
  }
  const clearDateFilter = async () => {
    setStartDate(null)
    setEndDate(null)
    setStartDate1(null)
    setEndDate1(null)
    setDateRange1(false)
    if (searchTerm) {
      try {
        setLoading(true)
        const response = await window.Platform.database.filterVisit({ filterField: searchTerm ? searchTerm.field : "date", filterValue: searchTerm?.value, pageNumber: paginationModel.page, startDate: '', endDate: '' })
        const jsonArrayWithId = response?.data?.map((obj, index) => ({ ...obj, id: index + 1 }));
        setAccessChanges(jsonArrayWithId)
        setRowCount(response.data1)

        setLoading(false)
      }
      catch (e) {
        console.log(e)
        window.NotificationUtils.showError("Error While Recieving Data Please Wait and try again");
        fetchVisits()

      }
    }
    else {
      setFilter(false)
      fetchVisits()
    }
  }

  return (
    <>

      <StaffEditorPageContainer>
        {loading && <OpaqueLoading />}
        <HeaderContainer>
          <div className="container-fluid" style={{ width: "100%" }}>
            <Paper elevation={3}
              sx={{
                p: 2,
                mb: 2,
                width: '100%',        // takes full width of parent
                // maxWidth: '1000px',   // optional: control max width
                mx: 'auto',
                backgroundColor: "#ebf0fa"          // center it horizontally
              }}>
              <div className="row mb-2">
                <div className="col-md-3">
                  <FormControl size="small" fullWidth>
                    <TextField
                      label="Search By Id, Name, Address"
                      size="small"
                      value={search}
                      placeholder="Type To Search"
                      className="form-control"
                      onChange={(e) => setSearch(e.target.value)}
                      sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}
                      InputLabelProps={{
                        shrink: true,
                        style: { color: "black", fontSize: "14px", fontWeight: 500 }
                      }}
                      inputProps={{
                        style: { color: "black", fontSize: "14px", fontWeight: 500 }
                      }}
                    />
                  </FormControl>
                </div>
                {userData?.role.includes('admin') && <div className="col-md-3">
                  <FormControl fullWidth size="small">
                    <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select HO</InputLabel>
                    <Select label="Select HO" value={rsm} variant="outlined" size="small" onChange={(e) => { setRsm(e.target.value); getUsers('rsm', e.target.value); setAsm(""); setRm("") }} sx={{ width: '100%', fontSize: 14, fontWeight: "500" }}>
                      <MenuItem value="" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>All</MenuItem>
                      {rsms.map((role) => (<MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>{role.name} - {role.username}</MenuItem>))}
                    </Select>
                  </FormControl>
                </div>}
                {userData?.role != 'asm' && <div className="col-md-3">
                  <FormControl fullWidth size="small">
                    <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select ARM</InputLabel>
                    <Select label="Select ARM" value={asm} variant="outlined" size="small" onChange={(e) => { setAsm(e.target.value); getUsers('asm', e.target.value); setRm("") }} sx={{ width: '100%', fontSize: 14, fontWeight: '500' }}>
                      <MenuItem value="" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>All</MenuItem>
                      {asms.map((role) => (<MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>{role.name} - {role.username}</MenuItem>))}
                    </Select>
                  </FormControl>
                </div>}
                <div className="col-md-3">
                  <FormControl fullWidth size="small">
                    <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select RM</InputLabel>
                    <Select label="Select RM" value={rm} variant="outlined" size="small" onChange={(e) => { setRm(e.target.value); getUsers('rm', e.target.value) }} sx={{ width: '100%', fontSize: 13, fontWeight: "500" }}>
                      <MenuItem value="" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>All</MenuItem>
                      {rms.map((role) => (<MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role.name} - {role.username}</MenuItem>))}
                    </Select>
                  </FormControl>
                </div>
              </div>
              <div className="row mt-3 mb-2">
                <div className="col-md-3">
                  <FormControl fullWidth size="small">
                    <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Status Type</InputLabel>
                    <Select label="Status Type" className="m-0 p-0 w-100" value={visitFilters?.visitStatus} onChange={(e) => setVisitFilters(prev => ({ ...prev, visitStatus: e.target.value }))} variant="outlined" size="small" sx={{ width: '100%', fontSize: 14, fontWeight: "500" }}>
                      <MenuItem value="" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>All</MenuItem>
                      {visitAllDropdown?.statusType?.map((role) => (<MenuItem key={role} value={role.statusTypeId} sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>{role.statusTypeName}</MenuItem>))}
                    </Select>
                  </FormControl>
                </div>
                <div className="col-md-3">
                  <FormControl fullWidth size="small">
                    <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Visit Outcome</InputLabel>
                    <Select label="Visit Outcome" value={visitFilters?.visitOutcome} onChange={(e) => setVisitFilters(prev => ({ ...prev, visitOutcome: e.target.value }))} variant="outlined" size="small" sx={{ width: '100%', fontSize: 14, fontWeight: "500" }}>
                      <MenuItem value="" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>All</MenuItem>
                      {visitAllDropdown?.visitOutcome?.map((role) => (<MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>{role.name}</MenuItem>))}
                    </Select>
                  </FormControl>
                </div>
                <div className="col-md-3">
                  <FormControl fullWidth size="small">
                    <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Verify Status</InputLabel>
                    <Select label="Verify Status" value={visitFilters?.verifyStatus} onChange={(e) => setVisitFilters(prev => ({ ...prev, verifyStatus: e.target.value }))} size="small" sx={{ width: '100%', fontSize: 14, fontWeight: "500" }}>
                      <MenuItem value="" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>All</MenuItem>
                      <MenuItem value={"verified"} sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Verified</MenuItem>
                      <MenuItem value={"not_verified"} sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Not Verified</MenuItem>
                    </Select>
                  </FormControl>
                </div>
                <div className="col-md-3">
                  <FormControl fullWidth size="small">
                    <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Visit Type</InputLabel>
                    <Select label="Visit type" value={visitFilters?.visitType} onChange={(e) => setVisitFilters(prev => ({ ...prev, visitType: e.target.value }))} variant="outlined" size="small" sx={{ width: '100%', fontSize: 14, fontWeight: "500" }}>
                      <MenuItem value="" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>All</MenuItem>
                      {visitType?.map((option) => (
                        <MenuItem key={option.routeVisitTypeID} value={option.routeVisitTypeID}>
                          {option.routeVisitType}
                        </MenuItem>
                      ))}
                      {/* {visitAllDropdown?.visitType?.map((role) => (<MenuItem key={role} value={role.visitTypeId} sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>{role.typeName}</MenuItem>))} */}
                    </Select>
                  </FormControl>
                </div>
              </div>
              <div className="row mt-2 mt-3 mb-2">
                <div className="col-md-3">
                  <FormControl fullWidth size="small">
                    <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Party Type</InputLabel>
                    <Select label="Party Type" value={visitFilters?.partyType} onChange={(e) => setVisitFilters(prev => ({ ...prev, partyType: e.target.value }))} variant="outlined" size="small" sx={{ width: '100%', fontSize: 14, fontWeight: "500" }}>
                      <MenuItem value="" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>All</MenuItem>
                      {visitAllDropdown?.partyType?.map((role) => (<MenuItem key={role} value={role.partyId} sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>{role.type}</MenuItem>))}
                    </Select>
                  </FormControl>
                </div>
                <div className="col-md-3 mb-0">
                  <FormControl fullWidth size="small">
                    <TextField label="From Date" size="small" type="date" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }} className="form-control" value={startDate} onChange={(e) => setStartDate(e.target.value)}
                      InputLabelProps={{
                        shrink: true,
                        style: { color: "black", fontSize: "14px", fontWeight: 500 }
                      }}
                      inputProps={{
                        style: { color: "black", fontSize: "14px", fontWeight: 500 }
                      }} />
                  </FormControl>
                </div>
                <div className="col-md-3 mb-0">
                  <FormControl fullWidth size="small">
                    <TextField label="To Date" size="small" type="date" className="form-control" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }} value={endDate} onChange={(e) => setEndDate(e.target.value)}
                      InputLabelProps={{
                        shrink: true,
                        style: { color: "black", fontSize: "14px", fontWeight: 500 }
                      }}
                      inputProps={{
                        style: { color: "black", fontSize: "14px", fontWeight: 500 }
                      }} />
                  </FormControl>
                </div>
                <div className="col-md-3">
                  <Button variant="contained" color="primary" startIcon={<img src={searchIcon} alt="icon" height={"21"} width={"21"} />} fullWidth sx={{ fontSize: '14px', borderRadius: '10px' }} onClick={() => { setCallApi(true); fetchVisits() }}>
                    Find
                  </Button>
                </div>

              </div>
              <div className="row mt-3 mb-0">
                <div className="col-md-3">
                  <Button variant="contained" color="secondary" startIcon={<img src={clearFilterImage} alt="icon" height={"21"} width={"21"} />} fullWidth sx={{ fontSize: '14px', borderRadius: '10px' }} onClick={() => clearFilters()}>
                    Clear Filters
                  </Button>
                </div>
                 {accessModulesData && accessModulesData[0]?.is_download?.toLowerCase() != "no" &&  <div className="col-md-3">
                <Button variant="contained" color="success" size="small" startIcon={<FileDownloadIcon />} fullWidth sx={{ fontSize: '14px', borderRadius: '10px' }} onClick={() => exportOrders()}>
                    Download
                  </Button>
                </div>}
                <div className="col-md-3">
                  <Button fullWidth startIcon={<img src={todayCalanerImage} alt="Today's Calendar" height={21} width={21} />} sx={{
                    fontSize: '14px',
                    borderRadius: '10px',
                    size: 'small',
                    fullWidth: true,
                    backgroundColor: '#c99b00',
                    color: 'white',
                    '&:hover': {
                      backgroundColor: '#706130',
                    }
                  }}
                    onClick={() => setOpenDialog(true)}>
                    Today's Visits
                  </Button>
                </div>

                {userData?.role == "super admin" && <div className="col-md-3">
                  {/* <Box display="flex" gap={2}> */}
                  <Button

                    variant={geoFencing ? "contained" : "outlined"}
                    color={geoFencing ? "success" : "primary"}
                    startIcon={<GpsFixedIcon />}
                    // onClick={() => setGeoFencing((prev) => !prev)}
                    onClick={() => handleGeoFencingToggle()}
                    sx={{ borderRadius: 8, fontWeight: 600, boxShadow: geoFencing ? 2 : 0, transition: "all 0.2s", px: 1, py: 0.5, textTransform: "none", fontSize: "14px" }}>
                    Geo Fencing {geoFencing ? "On" : "Off"}
                  </Button>
                  <Switch checked={geoFencing} onChange={handleGeoFencingToggle} color="success" />
                  {/* </Box> */}
                </div>}

                {/* {userData?.role.includes("admin") && <div className="col-md-2">
                  <Button variant="contained" color="success" size="small" startIcon={<FileDownloadIcon />} fullWidth sx={{ fontSize: '14px', borderRadius: '10px' }} onClick={() => exportSummary()}>
                    Work Summary Report
                  </Button>
                </div>} */}
              </div>
              {accessModulesData && accessModulesData[0]?.is_download?.toLowerCase() != "no" &&  <div className="row mt-2 mb-0">
                {userData?.role.includes("admin") && <div className="col-md-4">
                  <Button variant="contained" color="success" size="small" startIcon={<FileDownloadIcon />} fullWidth sx={{ fontSize: '14px', borderRadius: '10px' }} onClick={() => exportSummary()}>
                    Work Summary Report
                  </Button>
                </div>}
                <div className="col-md-4">
                  <Button variant="contained" color="success" size="small" startIcon={<FileDownloadIcon />} fullWidth sx={{ fontSize: '14px', borderRadius: '10px' }} onClick={() => exportNewReport()}>
                    Visit Summary Report
                  </Button>
                </div>
                {userData?.role.includes("admin") && <div className="col-md-4">
                  <Button variant="contained" color="success" size="small" startIcon={<FileDownloadIcon />} fullWidth sx={{ fontSize: '14px', borderRadius: '10px' }} onClick={() => exportSalesReport()}>
                    Visit Pattern Report
                  </Button>
                </div>}

              </div>}
              <div className="row mt-2 mb-0">
             {accessModulesData && accessModulesData[0]?.is_download?.toLowerCase() != "no" &&  <>   <div className="col-md-4">
                  <Button variant="contained" color="success" size="small" startIcon={<FileDownloadIcon />} fullWidth sx={{ fontSize: '14px', borderRadius: '10px', py: 0.5 }} onClick={() => exportQuickSummary()}>
                    Quick Summary School
                  </Button>
                </div>
                <div className="col-md-4">
                  <Button variant="contained" color="success" size="small" startIcon={<FileDownloadIcon />} fullWidth sx={{ fontSize: '14px', borderRadius: '10px', py: 0.5 }} onClick={() => downloadDistributorQuickSummary()}>
                    Quick Summary Distributor
                  </Button>
                </div>
                </>
                }
                    {/* <div className="col-md-4">
                                                                        <FormControl fullWidth size="small">
                                                                          <InputLabel
                                                                            sx={{ fontSize: "14px", fontWeight: "500", color: "#000" }}
                                                                          >
                                                                            Select Session
                                                                          </InputLabel>
                                                                          <Select
                                                                            label="Select Session"
                                                                            value={selectedSession}
                                                                            disabled={isSessionDisabled}
                                                                            sx={{ fontSize: "14px", fontWeight: "500", color: "#000" }}
                                                                            onChange={(e) => {
                                                                              const selected = sessions.find((item) => item.id === e.target.value);
                                                                              setSelectedSession(e.target.value);
                                                    
                                                                              if (selected) {
                                                                                // ✅ Convert UTC → IST (local date)
                                                                                const start = new Date(selected.startDate);
                                                                                const end = new Date(selected.endDate);
                                                    
                                                                                const startIST = new Date(start.getTime() + (5.5 * 60 * 60 * 1000))
                                                                                  .toISOString()
                                                                                  .split("T")[0];
                                                                                const endIST = new Date(end.getTime() + (5.5 * 60 * 60 * 1000))
                                                                                  .toISOString()
                                                                                  .split("T")[0];
                                                    
                                                                                setStartDate(startIST);
                                                                                setEndDate(endIST);
                                                    
                                                                                // ✅ Disable manual date range if session chosen
                                                                                setIsDateRangeDisabled(true);
                                                                              } else {
                                                                                // ✅ If cleared, re-enable date inputs
                                                                                setIsDateRangeDisabled(false);
                                                                              }
                                                                            }}
                                                    
                                                                          >
                                                                            <MenuItem value="">
                                                                              <em>Select Session</em>
                                                                            </MenuItem>
                                                                            {sessions.map((s) => (
                                                                              <MenuItem key={s.id} value={s.id}>
                                                                                {s.sessionName}
                                                                              </MenuItem>
                                                                            ))}
                                                                          </Select>
                                                                        </FormControl>
                                                                      </div> */}
              </div>
            </Paper>
            <Box display="flex" justifyContent="flex-end" gap={2}>
            {accessModulesData && accessModulesData[0]?.is_add?.toLowerCase() != "no" &&    <div className="col-md-3">
                <Button variant="contained" color="primary" className=" w-100"
                  onClick={() => addStartVisit()} sx={{ borderRadius: '10px', fontSize: "14px" }}>
                  <Add sx={{ mr: 1 }} />
                  Start Visit
                </Button>
              </div>}
              {/* <div className="col-md-3">
                <Button variant="contained" color="primary" className=" w-100"
                  onClick={() => addEndVisit()} sx={{ borderRadius: '10px' }}>
                  <Add sx={{ mr: 1 }} />
                  End Visit
                </Button>
              </div>
              <div className="col-md-3">
                <Button variant="contained" color="primary" className=" w-100"
                  onClick={() => addVisit()} sx={{ borderRadius: '10px' }}>
                  <Add sx={{ mr: 1 }} />
                  Add Visit
                </Button>
              </div> */}
            </Box>
          </div>

          {/* <Typography variant="h5">Visits Management</Typography> */}
          {/* <FabStyle variant="extended" color="primary" size='small'

onClick={()=>addVisit()}

>

<Add sx={{ mr: 1 }} />

Add Visit

</FabStyle> */}




        </HeaderContainer>
        <TableContainer>{renderContent()}</TableContainer>
      </StaffEditorPageContainer>
      {
        visitModal &&
        <VisitModal
          onClose={() => setVisitModal(false)}
          // initialData={regexes.filter(rx => rx.id === showEditFormModal)[0]}
          loading={loading}
          fetchData={() => fetchVisits()}
          status={true}
        //   onSubmit={updateWarehouseData}
        />
      }
      {
        startVisitModal &&
        <VisitStartModal
          onClose={() => setStartVisitModal(false)}
          // initialData={regexes.filter(rx => rx.id === showEditFormModal)[0]}
          loading={loading}
          fetchData={() => fetchVisits()}
          status={true}
        //   onSubmit={updateWarehouseData}
        />
      }
      {
        endVisitModal &&
        <VisitEndModal
          onClose={() => setEndVisitModal(false)}
          // initialData={regexes.filter(rx => rx.id === showEditFormModal)[0]}
          loading={loading}
          fetchData={() => fetchVisits()}
          status={true}
        //   onSubmit={updateWarehouseData}
        />
      }
      {
        editModal &&
        <VisitModal
          onClose={() => setEditModal(false)}
          // initialData={regexes.filter(rx => rx.id === showEditFormModal)[0]}
          loading={loading}
          fetchData={() => fetchVisits()}
          status={false}
          propData={dataModal}
        />
      }
      <Dialog open={imageModalOpen} onClose={() => setImageModalOpen(false)} maxWidth="md">
        <DialogContent sx={{ display: "flex", flexDirection: "column", alignItems: "flex-end", p: 2, position: "relative" }}>
          <IconButton aria-label="close" onClick={() => setImageModalOpen(false)} sx={{ position: "absolute", right: 8, top: 8, color: (theme) => theme.palette.grey[500], zIndex: 1 }}>
            <CloseIcon />
          </IconButton>
          <Box sx={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", minHeight: 200, minWidth: 200, }}>
            <img src={imageUrl} alt="Attendance" style={{ maxWidth: "100%", maxHeight: "70vh", height: "auto", width: "auto", borderRadius: 8, display: "block", margin: "0 auto" }} />
          </Box>
        </DialogContent>
      </Dialog>

      <Dialog open={endVisitModalOpen} onClose={() => { setEndVisitModalOpen(false); }} maxWidth="md" fullWidth >
        <DialogContent>
          <Typography variant="h6" gutterBottom sx={{ color: "black" }}>End Visit Details</Typography>
          <Box display="flex" flexDirection="column" gap={2} mt={1}>
            <div className="row">
              <div className="col-md-6">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DateTimePicker
                    sx={{ width: '100%', color: "black", fontSize: "14px", fontWeight: "500" }}
                    label="Start Visit Time"
                    value={endVisitRow?.startTime ? dayjs(endVisitRow.startTime) : null}
                    disabled
                    ampm={false}
                  />
                </LocalizationProvider>
              </div>
              <div className="col-md-6">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DateTimePicker
                    sx={{ width: '100%' }}
                    label="Start Meeting Time"
                    value={
                      endVisitRow?.start_time_meeting
                        ? dayjs(endVisitRow.start_time_meeting)
                        : (endVisitForm.startMeetingTime ? dayjs(endVisitForm.startMeetingTime) : null)
                    }
                    onChange={handleStartMeetingChange}
                    minDateTime={endVisitRow?.startTime ? dayjs(endVisitRow.startTime) : undefined}
                    maxDateTime={endVisitRow?.startTime ? dayjs(endVisitRow.startTime).endOf('day') : undefined}
                    shouldDisableDate={date =>
                      endVisitRow?.startTime
                        ? !dayjs(date).isSame(dayjs(endVisitRow.startTime), 'day')
                        : false
                    }
                    disabled={!!endVisitRow?.start_time_meeting}
                    ampm={false}
                  />
                </LocalizationProvider>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DateTimePicker
                    sx={{ width: '100%' }}
                    label="End Meeting Time"
                    value={
                      endVisitRow?.end_time_meeting
                        ? dayjs(endVisitRow.end_time_meeting)
                        : (endVisitForm.endMeetingTime ? dayjs(endVisitForm.endMeetingTime) : null)
                    }
                    onChange={newValue =>
                      setEndVisitForm(prev => ({
                        ...prev,
                        endMeetingTime: newValue ? newValue.toISOString() : "",
                      }))
                    }
                    minDateTime={
                      endVisitForm.startMeetingTime
                        ? dayjs(endVisitForm.startMeetingTime)
                        : (endVisitRow?.startTime ? dayjs(endVisitRow.startTime) : undefined)
                    }
                    maxDateTime={endVisitRow?.startTime ? dayjs(endVisitRow.startTime).endOf('day') : undefined}
                    shouldDisableDate={date =>
                      endVisitRow?.startTime
                        ? !dayjs(date).isSame(dayjs(endVisitRow.startTime), 'day')
                        : false
                    }
                    disabled={!!endVisitRow?.end_time_meeting}
                    ampm={false}
                  />
                </LocalizationProvider>
              </div>
              <div className="col-md-6">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DateTimePicker
                    sx={{ width: '100%' }}
                    label="End Visit Time"
                    value={
                      endVisitRow?.endTime
                        ? dayjs(endVisitRow.endTime)
                        : (endVisitForm.endVisitTime ? dayjs(endVisitForm.endVisitTime) : null)
                    }
                    onChange={newValue =>
                      setEndVisitForm(prev => ({
                        ...prev,
                        endVisitTime: newValue ? newValue.toISOString() : "",
                      }))
                    }
                    minDateTime={
                      endVisitForm.endMeetingTime
                        ? dayjs(endVisitForm.endMeetingTime)
                        : (endVisitForm.startMeetingTime
                          ? dayjs(endVisitForm.startMeetingTime)
                          : (endVisitRow?.startTime ? dayjs(endVisitRow.startTime) : undefined))
                    }
                    maxDateTime={endVisitRow?.startTime ? dayjs(endVisitRow.startTime).endOf('day') : undefined}
                    shouldDisableDate={date =>
                      endVisitRow?.startTime
                        ? !dayjs(date).isSame(dayjs(endVisitRow.startTime), 'day')
                        : false
                    }
                    disabled={!!endVisitRow?.endTime}
                    ampm={false}
                  />
                </LocalizationProvider>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <TextField
                  label="Remark"
                  name="remark"
                  value={endVisitForm.remark}
                  onChange={(e) => {
                    handleEndVisitFormChange(e);
                    if (errors.remark && e.target.value.trim()) {
                      setErrors(prev => ({ ...prev, remark: false }));
                    }
                  }}
                  fullWidth
                  error={errors.remark}
                  helperText={errors.remark ? "Remark is required." : ""}
                />

              </div>
              <div className="col-md-6">
                <TextField
                  label="Mobile Number"
                  name="mobileNumber"
                  value={endVisitForm.mobileNumber}
                  onChange={handleEndVisitFormChange}
                  fullWidth
                  type="number"
                  onWheel={(e) => e.target.blur()} // 👈 prevents scroll wheel increment/decrement
                  inputProps={{
                    inputMode: 'numeric',
                    pattern: '[0-9]*',
                  }}
                />

              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <TextField
                  label="Contact Name"
                  name="contactName"
                  value={endVisitForm.contactName}
                  onChange={handleEndVisitFormChange}
                  fullWidth
                />
              </div>
              <div className="col-md-6">
                <FormControl style={{ width: isMobile ? "100%" : "100%" }}>
                  <InputLabel id="status-of-visit-label">Status Of Visit</InputLabel>
                  <Select
                    labelId="status-of-visit-label"
                    id="status-of-visit"
                    name="statusOfVisit"
                    value={endVisitForm.statusOfVisit}
                    onChange={handleEndVisitFormChange}
                    label="Status Of Visit"
                  >
                    {statusWork?.map((option) => (
                      <MenuItem key={option.statusTypeId} value={option.statusTypeId}>
                        {option.statusTypeName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <FormControl style={{ width: isMobile ? "100%" : "100%" }}>
                  <InputLabel id="work-done" >Work Done</InputLabel>
                  <Select
                    label="Work Done"
                    labelId="work-done"
                    id="work-done"
                    name="workDone"
                    value={endVisitForm.workDone}
                    onChange={handleEndVisitFormChange}
                  >
                    {workDone?.map((option, optionIndex) => (
                      <MenuItem key={option.workDoneTableId} value={option.workDoneTableId}>
                        {option.workDoneName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl></div>
              <div className="col-md-6">
                <FormControl style={{ width: isMobile ? "100%" : "100%" }}>
                  <InputLabel id="feedback-label">Feedback</InputLabel>
                  <Select
                    labelId="feedback-label"
                    id="feedback"
                    name="feedback"
                    value={endVisitForm.feedback}
                    onChange={handleEndVisitFormChange}
                    label="Feedback"
                  >
                    {feedback?.map((option) => (
                      <MenuItem key={option.feedbackId} value={option.feedbackId}>
                        {option.feedbackName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            </div>

            <Box display="flex" justifyContent="flex-end" gap={2}>
              <Button onClick={() => setEndVisitModalOpen(false)} variant="outlined">Cancel</Button>
              <Button variant="contained" onClick={handleEndVisitSubmit}>Submit</Button>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>

      {openDialog && (
        <TodayVisitModal
        is_download = {accessModulesData && accessModulesData[0]?.is_download?.toLowerCase() != "no" ? true : false}
          onClose={() => setOpenDialog(false)}
        />
      )}

    </>
  );
}
